import { Configuration } from "@azure/msal-browser";

export default {
  apiUri:
    process.env.NODE_ENV === "production"
      ? "https://dwp.azure-api.net/diningservices"
      : "https://dwp-nonprod.azure-api.net/diningservices",
  apimSubscriptionKey:
    process.env.NODE_ENV === "production" ? "271653140ae540cfa338256b99cb27bc" : "04df563edebf4f8caaecb57983d92531",
};

export const msalConfig: Configuration = {
  auth: {
    clientId:
      process.env.NODE_ENV === "production"
        ? "212dd490-69a6-4b98-b7ed-0c390801ba4e"
        : "b08f31fe-731c-497d-8ea5-b131a80eb1f1",
    authority: "https://login.microsoftonline.com/microsoft.onmicrosoft.com",
    redirectUri: "/",
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: "localStorage",
  },
};

interface IAppInsightsConfig {
  instrumentationKey: string;
  enableCorsCorrelation: boolean;
  extensions?: any[]; // can't be more specific since type is not exposed.
  distributedTracingMode?: number;
}

export const appInsightsConfig: IAppInsightsConfig = {
  instrumentationKey:
    process.env.NODE_ENV === "production"
      ? "bfb0f366-9200-4672-9ff9-a25341da5286"
      : "2be060eb-a86d-419a-b3bc-7c7369b5168f",
  enableCorsCorrelation: true,
};
